import toString from './to-string';

var upperCase = function (str) {
  return toString(str).toUpperCase();
};

export default upperCase;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/upper-case.js
// module id = 79
// module chunks = 0